import { useState, useCallback, useEffect } from 'react'
import { getPreference, setPreference } from '@fs/zion-preferences'
import { useUser } from '@fs/zion-user'
import useIsMounted from './useIsMounted'

export default function useUserPref(prefKey) {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const [prefIsRetrieved, setPrefIsRetrieved] = useState(false)
  const [userPreferenceLocal, setUserPreferenceLocal] = useState(null)
  const fullPrefKey = `give.${prefKey}`
  const { signedIn, userLoading } = useUser()
  const isMounted = useIsMounted()
  useEffect(() => {
    const fetchPref = async () => {
      try {
        setLoading(true)
        const pref = await getPreference(fullPrefKey)
        setUserPreferenceLocal(pref)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
        setPrefIsRetrieved(true)
      }
    }
    if (signedIn && !userLoading && isMounted()) {
      fetchPref()
    } else {
      setLoading(false)
    }
  }, [fullPrefKey, signedIn, userLoading, isMounted])

  const setUserPreference = useCallback(
    async (value) => {
      setUserPreferenceLocal(value)
      if (signedIn && !userLoading) await setPreference(fullPrefKey, value)
    },
    [signedIn, userLoading, fullPrefKey]
  )

  return { error, loading, prefIsRetrieved, setUserPreference, userPreference: userPreferenceLocal }
}
